module.exports = __webpack_public_path__ + "static/img/no3.629d1d67.png";